import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "layout-default" }
const _hoisted_2 = {
  key: 0,
  class: "app-header-title"
}
const _hoisted_3 = {
  key: 0,
  class: "app-sidebar",
  "data-v-sticky-container": ""
}
const _hoisted_4 = {
  ref: "sticky",
  class: "app-sidebar__sticky-wrapper"
}
const _hoisted_5 = {
  class: "app-sidebar__inner",
  "data-v-sticky-inner": ""
}
const _hoisted_6 = {
  key: 1,
  class: "app-sidebar"
}
const _hoisted_7 = { class: "app-sidebar__inner" }
const _hoisted_8 = { class: "app-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _directive_sticky = _resolveDirective("sticky")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_header, {
      ref: "header",
      variant: _ctx.headerOptions?.variant || 'standard',
      "show-user-name": _ctx.headerOptions?.showUserName !== false,
      simplified: _ctx.headerOptions?.simplified || false
    }, {
      tools: _withCtx(() => [
        _renderSlot(_ctx.$slots, "header-tools", {}, () => [
          (_ctx.headline)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.headline), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 3
    }, 8, ["variant", "show-user-name", "simplified"]),
    _createElementVNode("div", {
      class: _normalizeClass(["app-content", _ctx.additionalClasses])
    }, [
      (_ctx.hasSidebar && _ctx.isSticky)
        ? (_openBlock(), _createElementBlock("aside", _hoisted_3, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.sidebarComponent), _normalizeProps(_guardReactiveProps(_ctx.sidebarProps)), null, 16))
              ])
            ])), [
              [_directive_sticky, _ctx.stickyOptions]
            ])
          ]))
        : (_ctx.hasSidebar && !_ctx.isSticky)
          ? (_openBlock(), _createElementBlock("aside", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.sidebarComponent), _normalizeProps(_guardReactiveProps(_ctx.sidebarProps)), null, 16))
              ])
            ]))
          : _createCommentVNode("", true),
      _createElementVNode("main", _hoisted_8, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 2)
  ]))
}